module.exports = __webpack_public_path__ + "static/media/img_23.2d69356d.png";